/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CircleEqual = [
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["path", { d: "M7 10h10" }],
  ["path", { d: "M7 14h10" }]
];

export { CircleEqual as default };
//# sourceMappingURL=circle-equal.js.map
